const BroadcastListOrigins = {
  PATIENT: 'patient',
  PROVIDER: 'provider',
};

export default BroadcastListOrigins;
